import { xor } from 'lodash';
import React, { useCallback } from 'react';
import { ButtonToolbar } from 'react-bootstrap';
import { connect } from 'react-redux';
import { selectImpactedEntities } from '../../modules/changeImpacts.js';
import GroupSearchSelect from '../GroupSearchSelect.jsx';

const mapStateToProps = (state, ownProps) => ({
  impactedGroups: selectImpactedEntities(ownProps.id)(state).impactedGroups,
});

GroupsFilter.defaultProps = {
  selectedGroupsIds: [],
};

function GroupsFilter({ impactedGroups, selectedGroupsIds, navigateAction }) {
  const selectedCount = selectedGroupsIds.length;

  const selectedGroups = selectedGroupsIds.reduce((acc, id) => {
    acc[id] = true;
    return acc;
  }, {});

  const filteredGroups = impactedGroups.filter((group) => !group.archived);

  const handleGroupSelect = useCallback(
    (group) => {
      const groupId = group.id;
      navigateAction({
        impactedGroupsIds: xor(selectedGroupsIds, [groupId]),
      });
    },
    [selectedGroupsIds, navigateAction]
  );

  const handleClearAll = useCallback(() => {
    navigateAction({
      impactedGroupsIds: [],
    });
  }, [navigateAction]);

  const title = selectedCount ? `${selectedCount} Selected` : 'All';

  return (
    <div className="flex-col report-filter">
      <div className="text-muted filter-label">
        Group, Team, Department Impacted
      </div>

      <ButtonToolbar>
        <GroupSearchSelect
          groups={filteredGroups}
          selectedGroups={selectedGroups}
          onSelectGroup={handleGroupSelect}
          onClearAll={handleClearAll}
          title={title}
          className="btn-block"
        />
      </ButtonToolbar>
    </div>
  );
}

export default connect(mapStateToProps)(GroupsFilter);
